export default __webpack_public_path__ + "static/media/017-croissant.ea7f706c.svg";